import React from 'react';

function ContactMe() {
  return (
    <>
      <main>
        <article id="fullpage">
          {/* Contact Me */}
          <section className="contactMe section" id="contactMe" aria-label="skill">
            <div className="container card contactMe-card" style={{ padding: '50px' }}>
              <div className="contactMe">
                <div className="contactForm">
                  <h2 className="headline headline-2 section-title" id="tag-label">
                    <span className="span">Contact Me</span>
                  </h2>
                  <p className="section-text">
                    Fill the Form Below & I will Contact You Soon
                  </p>
                  <form>
                    <div className="formGroup">
                      <label htmlFor="name">Name:</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        required
                        className="input-field"
                        autoComplete="off"
                      />
                    </div>
                    <div className="formGroup">
                      <label htmlFor="email">Email:</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                        className="input-field"
                        autoComplete="off"
                      />
                    </div>
                    <div className="formGroup textarea">
                      <label htmlFor="message">Message:</label>
                      <textarea
                        name="message"
                        placeholder="Your Message"
                        required
                        className="input-field "
                        autoComplete="off"
                      />
                    </div>
                    <button className="btn btn-primary">Send</button>
                  </form>
                </div>

                <div className="contactImage">
                  <img src="/assets/images/model-main.png" alt="Contact Me" />
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
    </>
  )
}

export default ContactMe;